import { AppRoutePaths } from '@core/types/app-route-paths';
import { AppAccessMode } from '@core/services/app-access.types';

const PUBLIC_ROUTE_PATHS = [`/${AppRoutePaths.Healthcheck}`];
const PUBLIC_ROUTE_PREFIXES = [`/${AppRoutePaths.RequestGuestView}/`];
const RESTRICTED_ROUTE_PREFIXES = [
  `/${AppRoutePaths.RequestView}/`,
  `/${AppRoutePaths.RequestGuestView}/`,
];
const WORKFLOW_ROUTE_SEGMENT = '/workflows';

export function isPublicAppPath(pathname: string): boolean {
  const normalizedPathname = getPathname(pathname);

  return (
    PUBLIC_ROUTE_PATHS.includes(normalizedPathname) ||
    PUBLIC_ROUTE_PREFIXES.some(prefix => normalizedPathname.startsWith(prefix))
  );
}

export function isRestrictedAppPath(pathname: string): boolean {
  return RESTRICTED_ROUTE_PREFIXES.some(prefix =>
    getPathname(pathname).startsWith(prefix),
  );
}

export function isWorkflowAppPath(pathname: string): boolean {
  return getPathname(pathname).includes(WORKFLOW_ROUTE_SEGMENT);
}

export function getAppAccessModeByUrl(url: string): AppAccessMode {
  return isPublicAppPath(url) ? 'public' : 'private';
}

function getPathname(url: string): string {
  // Fast path: already a plain pathname, no scheme/host to resolve.
  if (url.startsWith('/')) {
    return url.split('?')[0].split('#')[0];
  }

  try {
    return new URL(url, 'http://x-keeper.local').pathname;
  } catch {
    return url.split('?')[0].split('#')[0];
  }
}
